import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { NoImageIcon, PlusIcon } from "../assets/icons";
import { useDropzone } from "react-dropzone";
import { instance } from "../libs/client";
import generateFileUrl, { CDN } from "../utils/generateFileUrl";
import { useAlert } from "react-alert";
const UploadProfile = ({ onChange, value, type, title, subTitle, nodeId }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const alert = useAlert();
  const onDrop = useCallback((acceptedFiles) => {
    setLoading(true);
    var formData = new FormData();
    const size = acceptedFiles[0].size / 1024 / 1024;
    if (size < 2) {
      formData.append("file", acceptedFiles[0]);
      instance({
        method: "post",
        url: "file/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then(({ data }) => {
        if (onChange) {
          onChange(data.file);
        }
        setLoading(false);
      });
    } else {
      setLoading(false);
      alert.info(t("imageUploader:max2Mb"));
    }
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  return (
    <div
      className={`flex flex-row items-center focus:outline-none cursor-pointer group w-max ${type === "profile" ? " h-12" : ""
        }`}
      {...getRootProps()}
    >
      <div className="relative flex items-center gap-x-6 mt-2 xs:mt-0">
        <div
          className={`transition rounded-full bg-teal-200 group-hover:bg-teal-300 relative flex items-center justify-center text-main ${value ? "ring-[1px] w-10 h-10" : "ring-[10px] w-10 h-10"
            }  ring-teal-100 group-hover:ring-teal-200`}
        >
          {loading ? (
            <svg
              aria-hidden="true"
              className="w-8 h-8 text-teal-200 animate-spin dark:text-gray-600 fill-white"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          ) : value ? (
            <img
              src={
                value?.includes("https://cdn.upu.io")
                  ? value
                  : generateFileUrl(value)
              }
              className="opacity-100 absolute left-0 w-full h-full rounded-full "
            />
          ) : (
            <span className="text-teal-700  flex items-center justify-center">
              <NoImageIcon width={26} />
            </span>
          )}
        </div>
        <div className="flex flex-col mb-3 ">
          <p className="text-secondary-900 text-base font-medium ">
            {value ? title : title}
          </p>
          <p
            className={`underline text-xs text-secondary-500 hover:text-teal-500 mt-2`}
            onClick={() => onChange("")}
          >
            {value ? subTitle : t("fileInput:documentSubTitle")}
          </p>
        </div>
      </div>

      <input {...getInputProps()} type={"file"} className={"sr-only"} />
    </div>
  );
};

export default UploadProfile;
